import { h } from 'preact'
import { CablePhase } from '@tshmanager/chat-shared'
import { t } from '../chat-i18n.js'

/**
 * Subtle connection status when cable is connecting or reconnecting.
 */
export function CableStatusLine({ store }) {
  const phase = store.cablePhase?.value
  if (phase !== CablePhase.Connecting && phase !== CablePhase.Reconnecting) {
    return null
  }
  const label = phase === CablePhase.Reconnecting
    ? t('chat.cable.reconnecting')
    : t('chat.cable.connecting')

  return (
    <div class="chat-cable-status" role="status">
      <span class="chat-cable-status-spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  )
}
